/* Matapayals — lightweight wishlist (localStorage). Header icon + heart buttons + page helpers. */
(function () {
  'use strict';
  var WK = 'mp_wishlist', RK = 'mp_recently_viewed';

  function get(k){ try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch(e){ return []; } }
  function save(k,v){ try { localStorage.setItem(k, JSON.stringify(v)); } catch(e){} }
  function inWish(h){ return get(WK).indexOf(h) > -1; }
  function toggle(h){ var a = get(WK), i = a.indexOf(h); if(i>-1){ a.splice(i,1); } else { a.unshift(h); } save(WK,a); updateCount(); return i===-1; }
  function remove(h){ var a = get(WK), i = a.indexOf(h); if(i>-1){ a.splice(i,1); save(WK,a); updateCount(); } }
  function count(){ return get(WK).length; }

  function updateCount(){
    document.querySelectorAll('[data-mp-wish-count]').forEach(function(el){
      var c = count(); el.textContent = c; el.style.display = c>0 ? 'grid' : 'none';
    });
  }
  function markFavs(){
    document.querySelectorAll('[data-mp-fav][data-handle]').forEach(function(b){
      b.classList.toggle('on', inWish(b.getAttribute('data-handle')));
    });
  }

  function injectHeader(){
    if(document.querySelector('.mp-wish-link')) return;
    var cart = document.querySelector('.cart-link') || document.querySelector('a[href$="/cart"]');
    if(!cart) return;
    var a = document.createElement('a');
    a.href = '/pages/wishlist'; a.className = 'mp-wish-link'; a.setAttribute('aria-label', 'Wishlist');
    a.style.cssText = 'position:relative;display:inline-flex;align-items:center;justify-content:center;width:42px;height:42px;color:inherit;text-decoration:none;margin:0 2px;';
    a.innerHTML = '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 21C7 16.5 3 13.3 3 9.2 3 6.4 5.2 4 8 4c1.6 0 3.1.8 4 2 .9-1.2 2.4-2 4-2 2.8 0 5 2.4 5 5.2 0 4.1-4 7.3-9 11.8z"/></svg>' +
      '<span data-mp-wish-count style="position:absolute;top:1px;right:0;background:#ae2537;color:#fff;font-size:9px;font-weight:800;min-width:16px;height:16px;border-radius:50%;display:grid;place-items:center;padding:0 3px;">0</span>';
    cart.parentNode.insertBefore(a, cart);
    updateCount();
  }

  document.addEventListener('click', function(e){
    var f = e.target.closest('[data-mp-fav]');
    if(f && f.getAttribute('data-handle')){
      e.preventDefault(); e.stopPropagation();
      var added = toggle(f.getAttribute('data-handle'));
      f.classList.toggle('on', added);
      if(window.MPCart && added){ /* subtle: no drawer for wishlist */ }
    }
  });

  document.addEventListener('DOMContentLoaded', function(){ injectHeader(); markFavs(); updateCount(); });

  window.MPWish = {
    list: function(){ return get(WK); },
    recent: function(){ return get(RK); },
    remove: remove,
    inWish: inWish,
    updateCount: updateCount
  };
})();
